import type { WithActiveBranchId } from '@app/types';

export enum WarehousesEndpoints {
  UpdateWarehouse = 'UpdateWarehouse',
  SearchWarehouses = 'SearchWarehouses',
  GetWarehouseById = 'GetWarehouseById',
  GetWarehouses = 'GetWarehouses',
  GetBranchWarehouses = 'GetBranchWarehouses',
  GetCurrentBranchWarehouses = 'GetCurrentBranchWarehouses',
}

interface GetWarehouseByIdParams {
  warehouseId: number;
}

interface GetWarehousesParams {
  warehouseId?: number;
}

interface SearchWarehousesData {
  data: ModelWarehouseFilter;
}

interface UpdateWarehouseData {
  data: ModelWarehouse;
}
export interface ModelWarehouseFilter {
  SearchTerm: string | null;
  BranchIds: number[] | null;
  ItemsPerPage: number;
  Page: number;
}

export interface ModelWarehousesSearchResult {
  Filter: ModelWarehouseFilter;
  CountItems: number;
  Page: number;
  ItemsPerPage: number;
  Warehouses: ModelWarehouse[] | null;
}

export interface ModelWarehouse {
  Id: number;
  Name: string | null;
  Comment: string | null;
  IsDeleted: boolean;
  BranchIds: number[] | null;
  CountProducts: number;
}

export interface GetBranchWarehousesParams {
  branchId: number;
  warehouseId: number;
}

export type GetWarehousesRequest = WithActiveBranchId<GetWarehousesParams>;
export type UpdateWarehouseRequest = WithActiveBranchId<UpdateWarehouseData>;
export type SearchWarehousesRequest = WithActiveBranchId<SearchWarehousesData>;
export type GetWarehouseById = WithActiveBranchId<GetWarehouseByIdParams>;
export type GetBranchWarehousesRequest =
  WithActiveBranchId<GetBranchWarehousesParams>;
